import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaidarshancabs() {



const cardData = {
  keyword: " Mumbai Darshan Cabs",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai Darshan cab services for travelers who want to explore the famous attractions of Mumbai in a convenient and stress-free way. Whether you are visiting the city for the first time, planning a family sightseeing trip, or organizing a group tour, our Mumbai Darshan cab service ensures a smooth travel experience with professional drivers and well-maintained vehicles. We provide flexible booking options including half-day and full-day city tour packages at transparent and affordable pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from hotels, homes, or railway stations and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai Darshan sightseeing tours.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of the most iconic landmarks in Mumbai located along the Arabian Sea in South Mumbai. Built during the British era, the grand arch monument attracts thousands of visitors every day. Tourists come here to admire the historic architecture, take photographs, and enjoy boat rides to Elephanta Island. The surrounding Colaba area is lively with street vendors, cafes, and historic buildings, making it a popular starting point for Mumbai Darshan sightseeing tours."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a beautiful seaside boulevard stretching along the Arabian Sea and is popularly known as the Queen’s Necklace because of the sparkling lights visible at night. Visitors enjoy peaceful walks along the promenade, breathtaking sunset views, and the refreshing sea breeze. It is one of the best places in Mumbai to relax and experience the city’s coastal beauty. A comfortable cab ride allows travelers to enjoy the scenic drive and stop for photographs along the route."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus",
    description:
      "Chhatrapati Shivaji Maharaj Terminus, commonly known as CSMT, is a historic railway station and a UNESCO World Heritage Site. The building showcases magnificent Victorian Gothic architecture with detailed carvings, stained glass windows, and impressive domes. Apart from being a major railway hub, it is also one of Mumbai’s most photographed landmarks. Visitors enjoy exploring the architecture and learning about its historical importance during a Mumbai city tour."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is one of the most famous temples in Mumbai dedicated to Lord Ganesha. Devotees from across the country visit the temple to seek blessings and offer prayers. The temple is especially crowded during Ganesh Chaturthi and other religious occasions. Visitors appreciate the spiritual atmosphere and beautifully designed temple structure. Including this temple in a Mumbai Darshan cab tour allows travelers to experience an important religious landmark of the city."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a renowned Islamic shrine located on a small island in the Arabian Sea. The white marble structure stands beautifully in the water and is connected to the mainland by a narrow walkway that becomes visible during low tide. People from all religions visit the dargah to offer prayers and experience its peaceful surroundings. The location also provides beautiful sea views and is a popular stop during Mumbai sightseeing tours."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of the most famous beaches in Mumbai and a favorite hangout spot for both locals and tourists. Visitors come here to enjoy the sea breeze, relax on the sandy shore, and taste popular Mumbai street foods like pav bhaji, bhel puri, and pani puri. The beach becomes especially lively during the evening when families gather to watch the sunset. A cab ride makes it easy to visit Juhu Beach as part of a Mumbai Darshan tour."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is one of Mumbai’s most impressive engineering landmarks connecting Bandra and Worli across the Arabian Sea. The cable-stayed bridge offers stunning views of the sea and city skyline. Driving across the sea link is a memorable experience, especially during sunset or nighttime when the bridge lights up beautifully. Many sightseeing tours include this route to give travelers a scenic view of Mumbai’s modern infrastructure."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock-cut caves located on Elephanta Island in Mumbai Harbour. The caves are famous for their magnificent stone sculptures dedicated to Lord Shiva and date back several centuries. Visitors reach the island by ferry from the Gateway of India and explore the historic cave temples and carvings. The site is recognized as a UNESCO World Heritage Site and is an important cultural attraction included in many Mumbai sightseeing itineraries."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped terraced gardens located on Malabar Hill. The gardens offer panoramic views of Marine Drive and the Arabian Sea. Visitors enjoy walking among the greenery, relaxing in the peaceful environment, and taking photographs of the scenic surroundings. The garden is also known for its animal-shaped hedges and the famous ‘Old Woman’s Shoe’ structure."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is one of Mumbai’s most popular shopping streets known for its vibrant market atmosphere. Visitors can shop for clothes, accessories, jewelry, handicrafts, and souvenirs while enjoying the lively street culture. The area is also home to many cafes and restaurants where tourists can relax after shopping. Including Colaba Causeway in a Mumbai Darshan cab tour gives travelers a chance to experience the local markets and culture of the city."
  }
],




services: [
{
name: "Mumbai Darshan Cab",
description: "Mumbai Darshan cab service provides comfortable sightseeing travel for tourists exploring the famous attractions of Mumbai city. Our AC sedans and SUVs ensure relaxed travel while visiting popular destinations such as Gateway of India, Marine Drive, Siddhivinayak Temple, and Juhu Beach. Professional drivers are familiar with city routes and tourist locations, ensuring smooth travel throughout the tour. Pickup services are available from hotels, homes, railway stations, and Mumbai airport. Ideal for families, tourists, and group travel. Spacious seating and air-conditioned interiors provide comfort during the city tour. Flexible sightseeing schedules allow travelers to visit multiple locations conveniently. Reliable cab service ensures a memorable Mumbai sightseeing experience."
},
{
name: "Mumbai Darshan Taxi",
description: "Mumbai Darshan taxi offers convenient transportation for tourists planning a sightseeing tour of Mumbai. Our fleet includes comfortable AC sedans and SUVs suitable for full-day city tours. Experienced drivers guide passengers through major tourist attractions including temples, beaches, historical monuments, and shopping areas. Pickup services are available from hotels, homes, offices, and airports across Mumbai. Ideal for family travel, tourism visits, and weekend sightseeing. Spacious interiors ensure comfortable travel between destinations. Flexible travel schedules allow passengers to explore the city at their own pace. Reliable taxi service ensures enjoyable sightseeing travel."
},
{
name: "Mumbai Sightseeing Cab",
description: "Mumbai sightseeing cab service offers private transportation for visitors exploring the famous landmarks and attractions of the city. Our comfortable AC vehicles ensure smooth travel across Mumbai’s busy roads. Professional drivers ensure safe driving while covering major tourist destinations like Gateway of India, Haji Ali Dargah, Bandra Bandstand, and Marine Drive. Pickup services are available from homes, hotels, railway stations, and airport terminals. Ideal for tourists, families, and photography tours. Spacious seating ensures relaxed travel throughout the journey. Flexible sightseeing packages allow customized city tours. Reliable cab service ensures stress-free sightseeing experiences."
},
{
name: "Mumbai City Tour Cab",
description: "Mumbai city tour cab service provides convenient transportation for tourists exploring Mumbai’s iconic landmarks and cultural attractions. Our AC sedans and SUVs ensure comfortable travel while visiting famous places across the city. Professional drivers ensure safe driving and guide passengers through important tourist routes. Pickup services are available across Mumbai including hotels, homes, railway stations, and airports. Ideal for family trips, tourism travel, and weekend city tours. Spacious interiors ensure comfortable journeys between sightseeing spots. Flexible travel schedules allow travelers to explore the city comfortably. Reliable cab services ensure memorable city tour experiences."
},
{
name: "Mumbai Darshan Cab Service",
description: "Mumbai Darshan cab service offers reliable sightseeing transportation for travelers visiting the city’s popular attractions. Our fleet includes AC sedans and SUVs designed for comfortable city travel. Professional drivers ensure safe driving and punctual pickup services from hotels, homes, offices, and airports. Ideal for tourists visiting temples, beaches, heritage monuments, and shopping markets. Spacious seating ensures relaxed travel during sightseeing tours. Flexible city tour packages allow passengers to plan customized travel routes. Affordable pricing ensures convenient sightseeing trips. Trusted cab services ensure smooth travel across Mumbai."
},
{
name: "Mumbai Darshan Taxi Service",
description: "Mumbai Darshan taxi service provides comfortable transportation for tourists exploring the cultural and historical sites of Mumbai. Our AC vehicles ensure pleasant travel between major tourist attractions. Professional drivers ensure safe driving and reliable city navigation. Pickup services are available from homes, hotels, offices, railway stations, and airports across Mumbai. Ideal for family trips, tourism visits, and religious travel. Spacious interiors ensure comfortable journeys during the tour. Flexible sightseeing plans allow travelers to visit multiple locations easily. Reliable taxi services ensure enjoyable city tours."
},
{
name: "Mumbai Sightseeing Taxi",
description: "Mumbai sightseeing taxi offers convenient travel for tourists exploring the city's iconic attractions and landmarks. Comfortable AC vehicles ensure relaxed travel through busy city routes. Experienced drivers ensure safe driving while covering important tourist locations. Pickup services are available from hotels, homes, offices, railway stations, and airport terminals. Ideal for family travel, tourism visits, and cultural exploration. Spacious seating ensures comfort during sightseeing trips. Flexible travel schedules allow passengers to explore the city at their own pace. Reliable taxi services ensure smooth sightseeing experiences."
},
{
name: "Mumbai City Tour Taxi",
description: "Mumbai city tour taxi service provides reliable transportation for visitors planning a guided tour of Mumbai’s famous landmarks. Our AC sedans and SUVs ensure comfortable travel between tourist locations. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including hotels, homes, offices, and airport terminals. Ideal for tourists, families, and sightseeing groups. Spacious seating ensures relaxed journeys throughout the tour. Flexible travel schedules allow convenient sightseeing planning. Reliable taxi services ensure enjoyable city tours."
},
{
name: "Mumbai Darshan Cab Booking",
description: "Mumbai Darshan cab booking allows tourists to reserve vehicles easily for exploring the city's famous attractions. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure relaxed travel during the sightseeing tour. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from homes, hotels, offices, railway stations, and airports across Mumbai. Ideal for family travel, tourism visits, and weekend city tours. Flexible tour plans allow customized sightseeing routes. Reliable cab booking ensures smooth city travel."
},
{
name: "Mumbai Darshan Taxi Booking Online",
description: "Mumbai Darshan taxi booking online provides quick and easy reservations for tourists planning a sightseeing tour. Instant booking confirmation allows travelers to schedule rides conveniently. Comfortable AC vehicles ensure smooth travel across Mumbai’s tourist destinations. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from hotels, homes, offices, railway stations, and airport terminals. Ideal for tourists visiting famous temples, beaches, and monuments. Flexible travel options allow customized city tours. Reliable online taxi booking ensures hassle-free sightseeing."
},
{
name: "Mumbai Temple Darshan Cab",
description: "Mumbai temple darshan cab service offers convenient transportation for devotees visiting famous temples across the city. Our AC vehicles ensure comfortable travel between religious destinations. Professional drivers ensure safe driving and punctual pickup services for temple visits. Pickup services are available from homes, hotels, offices, and railway stations across Mumbai. Ideal for religious travel and spiritual tours including Siddhivinayak Temple, Mahalaxmi Temple, and ISKCON Temple. Spacious seating ensures comfortable journeys for families and pilgrims. Flexible travel schedules allow multiple temple visits in one trip. Reliable cab services ensure peaceful temple darshan travel."
},
{
name: "Mumbai Tourist Cab Service",
description: "Mumbai tourist cab service offers reliable transportation for visitors exploring the city’s popular attractions and cultural landmarks. Our fleet includes AC sedans and SUVs suitable for comfortable sightseeing travel. Professional drivers ensure safe driving and guide tourists through important city routes. Pickup services are available across Mumbai including hotels, homes, railway stations, and airports. Ideal for family tours, tourism travel, and group sightseeing. Spacious interiors ensure relaxed travel throughout the trip. Flexible tour plans allow customized city exploration. Trusted cab services ensure memorable Mumbai tourism experiences."
}
],

tableData: [
["Mumbai Darshan Cab","Mumbai Darshan Taxi"],
["Mumbai Sightseeing Cab","Mumbai City Tour Cab"],
["Mumbai Darshan Cab Service","Mumbai Darshan Taxi Service"],
["Mumbai Sightseeing Taxi","Mumbai City Tour Taxi"],
["Mumbai Darshan Cab Booking","Mumbai Darshan Taxi Booking Online"],
["Mumbai Temple Darshan Cab","Mumbai Tourist Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Mumbai Darshan Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with Mumbai sightseeing routes and major tourist attractions. They know the best routes, travel timings, and city shortcuts, ensuring a comfortable and enjoyable Mumbai Darshan experience."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai Darshan cab bookings. We clearly explain hourly packages, travel charges, and sightseeing plans before confirming your booking so there are no hidden costs."
  },
  {
    WhyChooseheading: "Full-Day Sightseeing Packages",
    WhyChoosedescription: "We provide convenient Mumbai Darshan packages covering famous attractions like Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, Haji Ali Dargah, and many more popular places."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized, ensuring a comfortable city sightseeing journey."
  },
  {
    WhyChooseheading: "Flexible Travel Plans",
    WhyChoosedescription: "Travelers can customize their Mumbai Darshan itinerary based on their interests. We offer half-day and full-day sightseeing options depending on the time available."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for families, tourists, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from hotels, homes, railway stations, and airports anywhere in Mumbai so your Mumbai Darshan tour starts smoothly."
  },
  {
    WhyChooseheading: "Reliable Mumbai Sightseeing Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many tourists for Mumbai Darshan trips. Our punctual drivers, comfortable vehicles, and professional service ensure a memorable sightseeing experience."
  }
]
};

const faqData = [
  { question: "What is included in a Mumbai Darshan cab package?", answer: "Mumbai Darshan packages usually include visits to popular attractions like Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, and Haji Ali Dargah." },
  { question: "Do you provide half-day and full-day Mumbai Darshan tours?", answer: "Yes, Omshree Cabs offers both half-day and full-day sightseeing cab packages in Mumbai." },
  { question: "Which vehicles are available for Mumbai Darshan travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from hotels or Mumbai Airport?", answer: "Yes, we provide pickup from hotels, homes, railway stations, and Mumbai Airport for Mumbai Darshan tours." },
  { question: "Can we customize the sightseeing places?", answer: "Yes, travelers can customize the sightseeing itinerary according to their preferences." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Is advance booking recommended for Mumbai Darshan?", answer: "Yes, advance booking is recommended especially during weekends and tourist seasons." },
  { question: "Do you provide group sightseeing tours?", answer: "Yes, SUVs and larger vehicles are available for family and group sightseeing tours." },
  { question: "How long does a Mumbai Darshan tour take?", answer: "A full Mumbai Darshan tour usually takes around 6–8 hours depending on the number of places visited." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Desai",
    feedback:
      "We booked Omshree Cabs for Mumbai Darshan and the experience was excellent. The driver guided us through all the major tourist spots comfortably.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Sharma",
    feedback:
      "Our Mumbai sightseeing trip with Omshree Cabs was wonderful. Clean vehicle, punctual driver, and a very smooth tour around the city.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Darshan Cabs",
  "description": "Book Mumbai Darshan Cabs with Omshree Cab for comfortable and convenient sightseeing. Enjoy city tours, temple darshan, and tourist trips with reliable taxi service. Affordable fares, easy online booking, and trusted cabs for Mumbai Darshan.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2000"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai Darshan Cabs | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai Darshan Cabs with Omshree Cab for city sightseeing, temple tours, and tourist trips. Reliable and affordable taxi service with easy online booking for Mumbai Darshan." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaidarshancabs;